export default __webpack_public_path__ + "static/media/blueslider1.e3b88d19.png";